<footer class="home-footer">

  <!-- Footer Main -->
  <div class="footer-main">

    <div class="footer-container">

      <!-- Company -->
      <div class="footer-col company-col">

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 70" class="ksna-logo" width="100%" height="100%">
          <!-- Icon representing Home & Electronics -->
          <g transform="translate(10, 10)">
            <!-- House Outline -->
            <path d="M25 0 L50 20 L50 50 L0 50 L0 20 Z" fill="none" stroke="#ffffff" stroke-width="4" stroke-linejoin="round"/>
            <!-- Lightning Bolt (Appliances/Electronics) -->
            <path d="M28 8 L14 28 L28 28 L20 44" fill="none" stroke="#0d6efd" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </g>

          <!-- Brand Text -->
          <text x="75" y="36" font-family="system-ui, -apple-system, sans-serif" font-size="26" font-weight="800" fill="#ffffff">KSNA</text>
          <text x="76" y="54" font-family="system-ui, -apple-system, sans-serif" font-size="13" font-weight="600" fill="#ffffff" letter-spacing="3">MARKETINGS</text>
        </svg>

        <p>
          Your trusted destination for quality products and customer satisfaction.
        </p>

        <div class="footer-info">

          <div>
            <i class="bi bi-geo-alt-fill"></i>
            Town Hall Rd, Madurai Main, Madurai, Tamil Nadu 625001
          </div>

          <div>
            <i class="bi bi-telephone-fill"></i>
            +91 89404 96182
          </div>

         <!-- <div>
            <i class="bi bi-envelope-fill"></i>
            info&#64;ksnamarketings.com
          </div>-->

        </div>

      </div>

      <!-- Google Map -->
      <div class="footer-col">

        <h4 class="footer-heading">
          <span class="heading-accent"></span>
          Our Location
        </h4>

        <div class="map-container">

          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.1905273604843!2d78.11196487450766!3d9.91808447443997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00db9576304981%3A0x576ddf77d8c5efae!2sKsna%20marketings!5e0!3m2!1sen!2sin!4v1785766294421!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>

        </div>

      </div>

      <!-- Connect -->
      <div class="footer-col">

        <h4 class="footer-heading">
          <span class="heading-accent"></span>
          Connect With Us
        </h4>

        <ul class="footer-links">

          <li>
            <a href="https://wa.me/08940496182" target="_blank">

              <span class="icon-wrapper">
                <i class="bi bi-whatsapp"></i>
              </span>

              WhatsApp

            </a>
          </li>

          <li>
            <a href="https://www.instagram.com/ksnamarketings?igsh=a2FrZDh5b3ZhZ281" target="_blank">

              <span class="icon-wrapper">
                <i class="bi bi-instagram"></i>
              </span>

              Instagram

            </a>
          </li>

          <li>
            <a href="https://maps.app.goo.gl/1Wd5zLvdkFwbCpXF9" target="_blank">

              <span class="icon-wrapper">
                <i class="bi bi-geo-alt-fill"></i>
              </span>

              Open in Google Maps

            </a>
          </li>

        </ul>

      </div>

    </div>

  </div>

  <!-- Footer Bottom -->
  <div class="footer-bottom">

    <div class="footer-container footer-bottom-inner">

      <span class="copyright">
        © {{ currentYear }}
        <strong>KSNA Marketings, Madurai</strong>
        —
        Designed & Developed by
        <a href="https://www.cktechsoln.in/" target="_blank" class="brand-link">
          CKTech Solution
        </a>
      </span>

    </div>

  </div>

</footer>
